/*
 * Copyright (c) Nexign, JSC, 2021-2024.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @author Ilya Baranchikov
 * @version 1.28.0
 * @since 1.16.0
 */

import { FOOTER_HEIGHT } from '@/main/components/common/Footer/styled/FooterStyled';

export const onboardingSetSpotlightHeight = (top: number, offsetBottom: number, height: number) => {
    document.querySelectorAll<HTMLElement>('.react-joyride__spotlight').forEach((el) => {
        const scrollHeight = window.innerHeight - top - offsetBottom - FOOTER_HEIGHT;
        el.style.height = `${height < scrollHeight ? height : scrollHeight}px`;
    });
};
